import React, { useEffect, useState } from "react";
import { getDocs, collection, query, where, doc, getDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase/config";
import { Card, Button, Container, Spinner, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import RetakeSubmissionData from '../control/RetakeSubmissionData.js';
import { readRetakeSubmissions } from '../control/RetakeSubmissionData.js';
import "../App.css";

const ProctorDashboard = () => {
  const [quizzes, setQuizzes] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState("");

  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    fetchData();
    rolesConfig();
    getSubmissions();
    fetchUserName();
  }, []);

  //
  // useEffect(() => {
  //   const user = auth.currentUser;
  //   if (user) {
  //     const userDocRef = doc(db, "users", user.uid);
  //     getDoc(userDocRef).then(docSnapshot => {
  //       if (docSnapshot.exists()) {
  //         const data = docSnapshot.data();
  //         setUserName(`${data.firstName} ${data.lastName}`);
  //         console.log(data.firstName);
  //
  //       }
  //     }).catch(error => {
  //       console.error("Error fetching user data: ", error);
  //     });
  //   }
  // }, []);
  //
  const fetchData = async () => {
    try {
      const quizSnapshot = await getDocs(collection(db, "quizzes"));
      setQuizzes(quizSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error("Error fetching quizzes:", error);
    } finally {
      setLoading(false);
    }
  };

  const getSubmissions = async () => {
    setSubmissions(await readRetakeSubmissions());
  };

  const fetchUserName = () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDocRef = doc(db, "users", user.uid); // Use doc() with the user UID as the document ID
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            const userData = userDocSnap.data();
            setUserName(`${userData.firstName} ${userData.lastName}`);
          } else {
            console.warn("No user document found with this UID.");
          }
        } catch (error) {
          console.error("Error fetching user name:", error);
        }
      }
    });
  };

  const rolesConfig = async () => {
    const user = auth.currentUser;
    if (user) {
      const userDocRef = collection(db, "users");
      const userDoc = await getDocs(userDocRef);
      userDoc.forEach((docSnap) => {
        if (docSnap.id === user.uid) {
          setRoles(docSnap.data().role || []);
        }
      });
    }
  };

  const roleNavigation = (rolesArray, index) => {
    if (rolesArray[index] === "Admin") navigate("/administratorDashboard");
    else if (rolesArray[index] === "Faculty") navigate("/faculty/dashboard");
    else if (rolesArray[index] === "Proctor") navigate("/proctorDashboard");
    else if (rolesArray[index] === "Instructor") navigate("/instructorDashboard");
  };

  const displayRole = () => {
    return roles.map((role, index) => (
      <Dropdown.Item key={index} onClick={() => roleNavigation(roles, index)}>
        {role} dashboard
      </Dropdown.Item>
    ));
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  return (
    <Container className="proctor-container">
      <div className="text-end mb-3">
        <DropdownButton
          onClick={rolesConfig}
          title="Switch Roles"
          id="bg-nested-dropdown"
          variant="success"
        >
          {displayRole()}
        </DropdownButton>
      </div>

      <h2 className="text-center mb-4">Proctor Dashboard</h2>

      {/* 👇 Personalized greeting with fallback */}
      <h4 className="text-center mb-4">Hello, {userName || "Proctor"}!</h4>

      <section className="mb-5">
        <h4 className="text-center">Available Quizzes</h4>
        <div className="d-flex flex-wrap justify-content-center">
          {quizzes.length === 0 ? (
            <p>No quizzes found.</p>
          ) : (
            quizzes.map((quiz) => (
              <Card key={quiz.id} className="quiz-card short-card">
                <Card.Body>
                  <Card.Title>{quiz.title || "Untitled Quiz"}</Card.Title>
                  <Card.Text>Course: {quiz.course || "N/A"}</Card.Text>
                  <Card.Text>Assigned To: {quiz.assignedTo || "N/A"}</Card.Text>
                  <div className="d-flex justify-content-between">
                    <Button
                      variant="success"
                      onClick={() => (window.location.href = quiz.pdf)}
                    >
                      View
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => window.open(quiz.pdf, "_blank")}
                    >
                      Download
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            ))
          )}
        </div>
      </section>

      <section>
        <h4 className="text-center">All Appointments</h4>
        {submissions.length === 0 ? (
          <p className="text-center">No appointments found.</p>
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th className="greenHeader">Student Name</th>
                <th className="greenHeader">Course Name</th>
                <th className="greenHeader">Email</th>
                <th className="greenHeader">Quiz</th>
                <th className="greenHeader">Tokens</th>
                <th className="greenHeader">Date</th>
                <th className="greenHeader">Time</th>
              </tr>
            </thead>
            <tbody>
              {submissions.map((submission, index) => (
                <tr key={index}>
                  <td>{submission.studentName || "Unknown"}</td>
                  <td>{submission.department || "N/A"}</td>
                  <td>{submission.email || submission.studentEmail || "N/A"}</td>
                  <td>{submission.quiz || "Untitled"}</td>
                  <td>{submission.tokens || "N/A"}</td>
                  <td>{submission.date || "N/A"}</td>
                  <td>{submission.time || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </section>
    </Container>
  );
};

export default ProctorDashboard;
